import { Star } from "lucide-react";
import { Reveal } from "./Reveal";

const REVIEWS = [
  {
    text: "We booked the Zanzariyu suite for our anniversary — the private pool at sunset was worth every rupee. The staff remembered our names by the second morning.",
    name: "Meera & Anand Patel",
    place: "Vadodara",
  },
  {
    text: "The cleanest resort near Anand, hands down. Breakfast at the garden restaurant, kids in the pool all day — we had already booked our next weekend before checking out.",
    name: "Hardik Desai",
    place: "Ahmedabad",
  },
  {
    text: "Hosted my daughter's engagement on the lawns — 300 guests and flawless arrangements. The team handled every detail so quietly we barely noticed them working.",
    name: "Jayshreeben Trivedi",
    place: "Nadiad",
  },
  {
    text: "The spa's hot-stone ritual undid months of back tension. Rooms smell of fresh linen, gardens are beautifully kept, and WhatsApp booking took two minutes.",
    name: "Dr. Kavita Rao",
    place: "Mumbai",
  },
];

export const Testimonials = () => (
  <section className="testimonials section-pad" data-testid="testimonials-section">
    <div className="section-heading">
      <Reveal><div><span className="eyebrow">04 — Guest words</span><h2>Loved, lived,<br /><em>remembered.</em></h2></div></Reveal>
      <Reveal delay={0.1}><p>Families, couples and celebrations — our guests say it better than we ever could.</p></Reveal>
    </div>
    <div className="review-grid">
      {REVIEWS.map((review, i) => (
        <Reveal key={review.name} delay={(i % 4) * 0.08} className="review-card" data-testid={`review-${i}`}>
          <div className="review-stars">
            {[...Array(5)].map((_, s) => <Star key={s} size={13} fill="currentColor" />)}
          </div>
          <p>“{review.text}”</p>
          <div className="review-author"><strong>{review.name}</strong><span>{review.place}</span></div>
        </Reveal>
      ))}
    </div>
  </section>
);
